import React, { useEffect, useState } from "react";
import { FormGroup, ModalBody, ModalFooter, Input } from "reactstrap";
import Axios from "../../../lib/Axios";
import ToastHandler from "../../../components/Common/ToastHandler";

const PrivacyPolicyCreateForm = ({ refetch,toggle }) => {
  const [text, setText] = useState("");

  const [toast, setToast] = useState(false);

  const [toastData, setToastData] = useState({
    title: "",
    message: "",
  });

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dt = {
      privacyPolicyContent: text,
    };
    try {
      const result = await Axios.post("/cms/cms-set/privacy-policy", dt);
      setToastData({
        message: "Submitted",
        title: "Success",
      });
      refetch();
    } catch (error) {
      if (error.status === 500) {
        setToastData({
          message: error.response.data.error.message,
          title: "Error",
        });
        setToast(true);
      } else if (error.status === 400) {
        setToastData({
          message: error.response.data.message,
          title: "Error",
        });
        setToast(true);
      }
    }finally{
      toggle()
    }
  };

  return (
    <>
      <form className="tablelist-form">
        <ModalBody>
          <div className="mb-3">
            <FormGroup className="mb-3">
              <Input
                type="textarea"
                id="multiLineText"
                value={text}
                onChange={handleChange}
                rows="5" // Number of visible lines
                placeholder="Type something here..."
              />
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="submit"
            className="btn btn-success"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </ModalFooter>
      </form>
      <ToastHandler
        open={toast}
        setOpen={setToast}
        duration={2000}
        message={toastData.message}
        title={toastData.title}
      />
    </>
  );
};

export default PrivacyPolicyCreateForm;
